(function () {
  'use strict';

  var KEY = 'larrysa_recent_products_v1';
  var MAX_ITEMS = 4;
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  function allowed() {
    return window.LARRYSA_PREFERENCES_ALLOWED === true;
  }

  function safeImage(value) {
    if (!value) return '';
    try {
      var url = new URL(value, location.origin);
      var hostname = url.hostname.toLowerCase();
      if (url.protocol !== 'https:') return '';
      if (hostname === 'cdn.shopify.com') return url.href;
      if ((hostname === 'www.larrysasbakery.com' || hostname.endsWith('.myshopify.com')) && url.pathname.startsWith('/cdn/shop/')) return url.href;
    } catch (error) {}
    return '';
  }

  function safeProduct(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var handle = String(raw.handle || '').trim();
    if (!/^[a-z0-9][a-z0-9-]{0,120}$/.test(handle)) return null;
    var href = '/products/' + handle;
    if (raw.href && String(raw.href).split('?')[0] !== href) return null;
    return {
      handle: handle,
      href: href,
      name: String(raw.name || '').trim().slice(0, 100),
      category: String(raw.category || '').trim().slice(0, 40),
      price: String(raw.price || '').trim().slice(0, 30),
      image: safeImage(raw.image),
      viewedAt: Number(raw.viewedAt) || Date.now()
    };
  }

  function readProducts() {
    if (!allowed()) return [];
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      var now = Date.now();
      return saved.map(safeProduct).map(function (item) {
        if (item && item.price) item.price = ptPrice(item.price);
        return item;
      }).filter(function (item) {
        return item && item.name && item.viewedAt <= now && now - item.viewedAt < MAX_AGE;
      }).slice(0, MAX_ITEMS);
    } catch (error) {
      return [];
    }
  }

  window.LarrysaRecentProducts = { read: readProducts };

  function remember(raw) {
    if (!allowed()) return;
    var item = safeProduct(raw);
    if (!item || !item.name) return;
    item.viewedAt = Date.now();
    try {
      var products = readProducts().filter(function (saved) { return saved.handle !== item.handle; });
      products.unshift(item);
      localStorage.setItem(KEY, JSON.stringify(products.slice(0, MAX_ITEMS)));
    } catch (error) {}
    render();
  }

  function fromElement(element) {
    return {
      handle: element.getAttribute('data-handle'),
      href: element.getAttribute('href') || element.getAttribute('data-href'),
      name: element.getAttribute('data-name'),
      category: element.getAttribute('data-kicker'),
      price: element.getAttribute('data-price'),
      image: element.getAttribute('data-img')
    };
  }

  // Preços guardados antes de t54 vinham como "€27,00"; mostrar sempre "27,00 €".
  function ptPrice(value) {
    var match = /^\s*€\s?(\d[\d.]*,\d{2})\s*$/.exec(String(value || ''));
    return match ? match[1] + ' €' : value;
  }

  function render() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var list = section.querySelector('[data-recent-list]');
    if (!list) return;
    list.replaceChildren();
    var products = readProducts();
    section.hidden = products.length === 0;
    products.forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'be-recent__item';
      link.href = product.href;
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        link.appendChild(image);
      }
      var copy = document.createElement('span');
      copy.className = 'be-recent__copy';
      var name = document.createElement('strong');
      name.textContent = product.name;
      copy.appendChild(name);
      if (product.price) {
        var price = document.createElement('small');
        price.textContent = product.price;
        copy.appendChild(price);
      }
      link.appendChild(copy);
      list.appendChild(link);
    });
  }

  function initMobileAction() {
    var action = document.querySelector('[data-mobile-order-cta]');
    var hero = document.querySelector('.be-home-hero');
    var order = document.querySelector('#encomendar');
    if (!action || !hero || !order || !window.IntersectionObserver) return;
    var heroVisible = true;
    var orderVisible = false;
    var orderPassed = false;
    function update() {
      action.hidden = !window.matchMedia('(max-width: 760px)').matches || heroVisible || orderVisible || orderPassed;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === order) {
          orderVisible = entry.isIntersecting;
          orderPassed = entry.boundingClientRect.top < 0;
        }
      });
      update();
    });
    observer.observe(hero);
    observer.observe(order);
    window.addEventListener('resize', update);
    update();
  }

  function initDeferredImages() {
    var images = document.querySelectorAll('img[data-deferred-src]');
    if (!images.length) return;
    function load(image) {
      var src = image.getAttribute('data-deferred-src');
      if (!src) return;
      var picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source[data-deferred-srcset]').forEach(function (source) {
          source.setAttribute('srcset', source.getAttribute('data-deferred-srcset'));
          source.removeAttribute('data-deferred-srcset');
        });
      }
      var srcset = image.getAttribute('data-deferred-srcset');
      if (srcset) image.setAttribute('srcset', srcset);
      image.setAttribute('src', src);
      image.removeAttribute('data-deferred-srcset');
      image.removeAttribute('data-deferred-src');
    }
    if (!window.IntersectionObserver) {
      images.forEach(load);
      return;
    }
    function observe(items, margin) {
      if (!items.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          load(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: margin });
      items.forEach(function (image) { observer.observe(image); });
    }
    var categories = [];
    var products = [];
    images.forEach(function (image) {
      (image.closest('.be-categories__item') ? categories : products).push(image);
    });
    observe(categories, '100px 0px');
    observe(products, '500px 0px');
  }

  function init() {
    render();
    var product = document.querySelector('.product[data-recent-product]');
    if (product) remember(fromElement(product));
    initMobileAction();
    initDeferredImages();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var clear = target.closest('[data-recent-clear]');
    if (clear) {
      try { localStorage.removeItem(KEY); } catch (error) {}
      render();
      return;
    }
    var card = target.closest('[data-modal-card]') || target.closest('[data-recent-product]');
    if (card) remember(fromElement(card));
  });

  function syncPreferences() {
    if (!allowed()) {
      try { localStorage.removeItem(KEY); } catch (error) {}
    }
    init();
  }

  document.addEventListener('visitorConsentCollected', syncPreferences);
  document.addEventListener('larrysa:privacy', syncPreferences);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
